import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import store from 'store';
import { mountVue, unMountVue } from 'utils/vueContainer';
import * as config from 'config';
import defaultTransition from './transitions/default';

barba.use(barbaPrefetch);

const vueContainerClass = 'js-vueContainerBarba';

// Disable Scroll Restoration in Chrome
if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

barba.init({
    debug: config?.APP_ENV === 'local',
    timeout: 10000,
    transitions: [
        defaultTransition,
    ],
    prevent: ({ el }) => {
        const href = el.href.toLowerCase();

        if (/storage/.test(href)) return true;

        if (/admin/.test(href)) return true;

        if (/.pdf/.test(href)) return true;

        return false;
    },
});

barba.hooks.before(() => {
    barba.wrapper.classList.add('is-animating');
});
barba.hooks.after(() => {
    barba.wrapper.classList.remove('is-animating');
});


// ------------------------------------------------------------------------
// INITIALIZE VUE CONTAINER
// ------------------------------------------------------------------------

// Initialize barba vue container once
document.addEventListener('AppReady', () => {
    barba.mountedVue = mountVue(`.${vueContainerClass}`, document);
});

// If the new container is loaded, we need to make sure, vue components are initialized in the new container
// and vue components of the old container are removed correctly
// Therefore, we mount the barba vue container when the new page is ready
barba.hooks.beforeEnter(({ next }) => {
    // Only do this, when there is already an existing mounted instance(s), since the hooks are called
    // in a different order depending on whether it is a `sync: false` transition or not
    // In the case where they happen in sync we need to store the mountedVue while we create a new one
    if (barba.mountedVue) {
        barba.oldMountedVue = barba.mountedVue;
    }
    window.scrollTo(0, 0);
    barba.mountedVue = mountVue(`.${vueContainerClass}`, next.container);
});

// And if the old container is finished animating (and should be invisible by now),
// we can unmount all vue elements in the old container. This will correctly call "destroy()"
// on this vue components.
barba.hooks.afterLeave(() => {
    // if there is an oldMountedVue, unmount that one, since we already mounted the new one
    if (barba.oldMountedVue) {
        unMountVue(barba.oldMountedVue);
        barba.oldMountedVue = false;
    } else { // otherwise just unmount it
        unMountVue(barba.mountedVue);
        barba.mountedVue = false;
    }
});


// ------------------------------------------------------------------------
// UPDATE ACTIVE URL & TRACKING CODE
// ------------------------------------------------------------------------
// Set initial values
document.addEventListener('AppReady', () => {
    store.commit('app/setActiveUrl', window.location.href);
    const element = document.querySelector('[data-barba-namespace]');
    if (element) store.commit('app/setNamespace', element.getAttribute('data-barba-namespace'));
});

barba.hooks.beforeEnter(({ next }) => {
    // Add active URL and namespace to store (so main navigation can react)
    store.commit('app/setActiveUrl', next.url.href);
    store.commit('app/setNamespace', next.namespace);
});

barba.hooks.after(({ next }) => {
    // Track Pageview with Matomo
    if (typeof window._paq !== 'undefined') {
        window._paq.push(['setCustomUrl', next.url.href]);
        window._paq.push(['trackPageView']);
    }

    // Track Pageview with GoogleAnalytics
    if (typeof window.gtag !== 'undefined' && window.ua_id) {
        const path = (window.location.href).replace(window.location.origin, '').toLowerCase();
        window.gtag('js', new Date());
        window.gtag('config', window.ua_id, {
            anonymize_ip: true,
            page_title: document.title,
            page_path: path,
        });
    }

    // Reset loading state when changing view
    store.commit('app/setLoading', false);
});
